const mediaItems = [
  {
    title: '某顶流男星酒店密会全程时间线还原',
    duration: '15:28',
    views: '892万',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20stylized%20cinematic%20illustration%20of%20a%20luxury%20hotel%20corridor%20at%20night%20with%20dramatic%20lighting%2C%20warm%20coral%20and%20amber%20tones%2C%20mysterious%20atmosphere%2C%20editorial%20magazine%20style%2C%20film%20noir%20aesthetic%2C%20no%20text%20no%20letters&width=600&height=400&seq=media-01&orientation=landscape',
  },
  {
    title: '综艺录制冲突现场独家画面流出',
    duration: '08:42',
    views: '756万',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20stylized%20illustration%20of%20a%20TV%20studio%20set%20with%20dramatic%20red%20lighting%20and%20scattered%20papers%2C%20chaotic%20atmosphere%2C%20warm%20coral%20and%20amber%20color%20palette%2C%20editorial%20design%20style%2C%20cinematic%20composition%2C%20no%20text%20no%20letters&width=600&height=400&seq=media-02&orientation=landscape',
  },
  {
    title: '网红带货翻车当晚品牌方内部会议录音',
    duration: '22:15',
    views: '634万',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20stylized%20modern%20illustration%20of%20a%20corporate%20boardroom%20with%20dramatic%20lighting%20and%20tense%20atmosphere%2C%20warm%20coral%20and%20amber%20tones%2C%20business%20crisis%20concept%2C%20editorial%20magazine%20aesthetic%2C%20dark%20background%20with%20spotlight%2C%20no%20text%20no%20letters&width=600&height=400&seq=media-03&orientation=landscape',
  },
  {
    title: '影视剧删减片段全版本对比解析',
    duration: '12:50',
    views: '521万',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20stylized%20cinematic%20illustration%20of%20film%20strips%20with%20scissors%20cutting%20through%20in%20dramatic%20lighting%2C%20warm%20coral%20and%20amber%20color%20scheme%2C%20editorial%20design%20aesthetic%2C%20creative%20magazine%20style%2C%20dark%20atmosphere%20with%20accent%20light%2C%20no%20text%20no%20letters&width=600&height=400&seq=media-04&orientation=landscape',
  },
  {
    title: '社交平台小号被扒全过程技术复盘',
    duration: '18:33',
    views: '489万',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20stylized%20modern%20illustration%20of%20a%20magnifying%20glass%20over%20social%20media%20interface%20screens%2C%20investigation%20concept%2C%20warm%20coral%20and%20amber%20tones%2C%20editorial%20magazine%20aesthetic%2C%20dark%20background%20with%20soft%20glow%2C%20no%20text%20no%20letters&width=600&height=400&seq=media-05&orientation=landscape',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="w-full py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            视频爆料
          </h2>
          <p className="text-sm md:text-base text-foreground-600">
            独家视频还原事件真相，图文之外更直观的吃瓜体验
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {mediaItems.slice(0, 3).map((item, idx) => (
            <div
              key={idx}
              className="group bg-background-50 rounded-2xl overflow-hidden border border-background-200/60 hover:border-accent-300/50 transition-all cursor-pointer"
            >
              <div className="aspect-[3/2] overflow-hidden relative">
                <img
                  src={item.imageUrl}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-12 h-12 md:w-14 md:h-14 rounded-full bg-background-50/90 flex items-center justify-center group-hover:scale-110 transition-transform">
                    <i className="ri-play-fill text-xl md:text-2xl text-primary-600 ml-0.5"></i>
                  </div>
                </div>
                <span className="absolute bottom-3 right-3 text-xs bg-black/70 text-background-50 px-2 py-0.5 rounded-md font-medium">
                  {item.duration}
                </span>
              </div>
              <div className="p-4">
                <h3 className="text-sm md:text-base font-heading font-bold text-foreground-950 mb-2 group-hover:text-primary-600 transition-colors line-clamp-2">
                  {item.title}
                </h3>
                <div className="flex items-center gap-1 text-xs text-foreground-500">
                  <i className="ri-eye-line"></i>
                  <span>{item.views} 次观看</span>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 md:gap-6 mt-5 md:mt-6">
          {mediaItems.slice(3, 5).map((item, idx) => (
            <div
              key={idx + 3}
              className="group bg-background-50 rounded-2xl overflow-hidden border border-background-200/60 hover:border-accent-300/50 transition-all cursor-pointer flex flex-col sm:flex-row"
            >
              <div className="sm:w-56 flex-shrink-0 aspect-[3/2] sm:aspect-auto overflow-hidden relative">
                <img
                  src={item.imageUrl}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-10 h-10 rounded-full bg-background-50/90 flex items-center justify-center group-hover:scale-110 transition-transform">
                    <i className="ri-play-fill text-lg text-primary-600 ml-0.5"></i>
                  </div>
                </div>
                <span className="absolute bottom-2 right-2 text-xs bg-black/70 text-background-50 px-1.5 py-0.5 rounded-md font-medium">
                  {item.duration}
                </span>
              </div>
              <div className="p-4 flex-1 flex flex-col justify-center">
                <h3 className="text-sm md:text-base font-heading font-bold text-foreground-950 mb-2 group-hover:text-primary-600 transition-colors line-clamp-2">
                  {item.title}
                </h3>
                <div className="flex items-center gap-1 text-xs text-foreground-500">
                  <i className="ri-eye-line"></i>
                  <span>{item.views} 次观看</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}